import React from 'react';

/**
 * Friendly EdTech hero illustration: a stylised "student insight card"
 * showing the three SRL loops (Plan / Do / Reflect) as overlapping arcs
 * with soft mint + coral palette. Pure SVG, no images, no deps.
 */
function HeroVisual() {
    return (
        <div className="hero-visual-container" aria-hidden="true">
            {/* Floating blobs behind the card */}
            <div className="hero-blob hero-blob--mint" />
            <div className="hero-blob hero-blob--coral" />
            <div className="hero-blob hero-blob--sun" />

            <div className="hero-card">
                <div className="hero-card-head">
                    <div className="hero-card-dot hero-card-dot--coral" />
                    <div className="hero-card-dot hero-card-dot--sun" />
                    <div className="hero-card-dot hero-card-dot--mint" />
                    <span className="hero-card-title">Your week of learning</span>
                </div>

                <div className="hero-card-body">
                    <div className="hero-loop-row">
                        <LoopChip label="Plan" pct={82} tone="mint" />
                        <LoopChip label="Do" pct={67} tone="sun" />
                        <LoopChip label="Reflect" pct={45} tone="coral" />
                    </div>

                    <svg
                        className="hero-spark"
                        viewBox="0 0 360 96"
                        xmlns="http://www.w3.org/2000/svg"
                        role="img"
                        preserveAspectRatio="none"
                    >
                        <title>Reflection trend across weeks</title>
                        <defs>
                            <linearGradient id="sparkFill" x1="0" x2="0" y1="0" y2="1">
                                <stop offset="0%" stopColor="var(--srl-mint)" stopOpacity="0.35" />
                                <stop offset="100%" stopColor="var(--srl-mint)" stopOpacity="0" />
                            </linearGradient>
                        </defs>
                        <path
                            d="M0,72 C40,60 60,68 90,52 C120,36 150,46 180,40 C210,34 240,20 270,28 C300,36 330,18 360,12 L360,96 L0,96 Z"
                            fill="url(#sparkFill)"
                        />
                        <path
                            d="M0,72 C40,60 60,68 90,52 C120,36 150,46 180,40 C210,34 240,20 270,28 C300,36 330,18 360,12"
                            fill="none"
                            stroke="var(--srl-mint-ink)"
                            strokeWidth="2.5"
                            strokeLinecap="round"
                        />
                    </svg>

                    <div className="hero-strategy">
                        <span className="hero-strategy-label">Last unit · what worked</span>
                        <div className="hero-strategy-pills">
                            <span className="hero-pill hero-pill--mint">Pre-study planning</span>
                            <span className="hero-pill hero-pill--coral">Self-quizzing</span>
                            <span className="hero-pill hero-pill--ink-faint">Re-reading</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

function LoopChip({ label, pct, tone }) {
    const r = 26;
    const c = 2 * Math.PI * r;
    const dash = (pct / 100) * c;
    return (
        <div className={`hero-loop hero-loop--${tone}`}>
            <svg viewBox="0 0 64 64" width="64" height="64" aria-hidden="true">
                <circle cx="32" cy="32" r={r} className="hero-loop-track" />
                <circle
                    cx="32"
                    cy="32"
                    r={r}
                    className="hero-loop-fg"
                    strokeDasharray={`${dash} ${c}`}
                    transform="rotate(-90 32 32)"
                />
            </svg>
            <div className="hero-loop-meta">
                <span className="hero-loop-pct">{pct}%</span>
                <span className="hero-loop-label">{label}</span>
            </div>
        </div>
    );
}

export default HeroVisual;
